import $ from 'jquery';
import ko from 'lib/knockout';

/**
 *
 * @param {object} page
 * @param {PageCommentsViewModel} commentsModel
 * @return {newComment}
 */
export function init(page, commentsModel) {
	let model = new newComment(page.page_id, commentsModel);
	ko.applyBindings(model, $('#comment_add_wrap')[0]);
	return model;
}

class newComment {
    pageId = null;
    commentsModel = null;
    text = ko.observable('');
    progress = ko.observable(false);
    valid = ko.computed(() => {return (this.text().replace(' ', '').length > 0) && !this.progress()});

    constructor(pageId, commentsModel) {
        this.pageId = pageId;
        this.commentsModel = commentsModel;
    }

    save(model, event, userId = null) {
        if(USER_ID || userId) {
            this.progress(true);

            let data = {
                comments_page_id: this.pageId,
                comments_content: this.text()
            };
            if (this.commentsModel.comments().length > 0) {
                data.after_date = this.commentsModel.comments()[0].comments_date;
            }
            $.post(
                site_url('blog/comments_save'),
                data,
                (response) => {
                    if(response.success) {
                        this.text('');
                        for(let i = response.comments.length - 1; i >= 0; i--) {
                            this.commentsModel.comments.unshift(response.comments[i]);
                        }
                    } else if(response.message !== undefined) {
                        zde.notifier.error(response.message);
                    }
                    this.progress(false);
                },
                'json'
            );
        } else {
            zde.showLogin((data) => {
                if(data) {
                    this.save(model, event, data.id);
                    return;
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./modules/blog/pagecomments/newcomment.js